import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaBadge from './VaBadge.vue'

export const VaBadge = withConfigTransport(_VaBadge)
